export enum LightDiagnosticOriginType {
  PLANNER_ONBOARDING = 'planner_onboarding',
  FINANCIAL_ADVISOR_REFERRAL_FLOW = 'financial_advisor_referral_flow',
  SELF_REFERRAL_FLOW = 'self_referral_flow',
  SELF_SERVE_UPGRADE = 'self_serve_upgrade'
}
